// Identiek aan Syntess.Atrium.API/PdfType.cs
export enum pdfType {
    NotAvailable,
    PdfGen,
    ExtDoc
}